export type CommunicationTask = {
  id: number;
  name: string;
  rules: CommunicationAlertRules;
};

export type CommunicationAlertRules = {
  email: boolean;
  notification: boolean;
  sms: boolean;
};

export type CommunicationCategory = {
  id: number;
  name: string;
  rules: CommunicationAlertRules;
  list: CommunicationTask[];
};

class CommunicationAlert {
  id: number;
  name: string;
  categories: CommunicationCategory[];

  constructor(id: number, name: string, categories: CommunicationCategory[]) {
    this.id = id;
    this.name = name;
    this.categories = categories;
  }
}

export { CommunicationAlert };
